import React from 'react';
import { Space, Image } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import { isImageAttachment } from '../utils/attachments';

// Renders test-result files: pictures inline (click to zoom), documents as links.
// Used everywhere a lab result is shown, so the doctor reads the original sheet
// instead of a value someone retyped by hand.
const AttachmentPreview = ({ files, size = 40 }) => {
    if (!files || files.length === 0) return null;

    return (
        <Image.PreviewGroup>
            <Space size={4} wrap>
                {files.map((file, index) =>
                    isImageAttachment(file) ? (
                        <Image
                            key={file.fileUrl || index}
                            src={file.fileUrl}
                            width={size}
                            height={size}
                            style={{ objectFit: 'cover', borderRadius: 4, border: '1px solid #f0f0f0' }}
                        />
                    ) : (
                        <a
                            key={file.fileUrl || index}
                            href={file.fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            title={file.fileName}
                            style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}
                        >
                            <FileTextOutlined style={{ fontSize: Math.max(16, size / 2) }} />
                        </a>
                    )
                )}
            </Space>
        </Image.PreviewGroup>
    );
};

export default AttachmentPreview;
